import { Link } from "react-router-dom";
import Button from "components/button";
import {
  DotsVerticalIcon,
  EyeIcon,
  PencilIcon,
} from "@heroicons/react/outline";
import { TooltipParagraph } from "components/tooltipParagraph";
import moment from "moment";
import { SwitchButton } from "components/switchButton";
import { DropdownMenu } from "components/dropdownMenu";
import { EwaiverType } from "routes/ewaiver/hooks/useEwaiver";
import { isHaveActionPermission } from "utills/helpers";

interface PropType {
  data?: EwaiverType[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (item: EwaiverType) => void;
  handleApplyAction: (type: string, value: EwaiverType) => void;
}

export const EwaiverDataTable = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
  handleApplyAction,
}: PropType) => {
  const renderEventName = (item: EwaiverType) => {
    if (item?.event_name_vi !== "") return item?.event_name_vi;
    if (item?.event_name !== "") return item?.event_name;

    return "";
  };

  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>

              <th scope="col" className="th">
                Event name
              </th>

              <th scope="col" className="th">
                eWaiver Start Date Time
              </th>

              <th scope="col" className="th">
                eWaiver End Date Time
              </th>

              <th scope="col" className="th">
                Status
              </th>

              <th scope="col" className="th w-28">
                <span className="sr-only">Action</span>
                <p className="">Action</p>
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item: EwaiverType, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>

                <td className="td overflow-x-auto max-w-40">
                  <TooltipParagraph
                    text={renderEventName(item)}
                    className="whitespace-pre-wrap max-w-[280px]"
                  />
                </td>

                <td className="td overflow-x-auto">
                  {item?.start_checkin_online_date
                    ? moment(item?.start_checkin_online_date).format(
                        "DD/MM/YYYY HH:mm:ss"
                      )
                    : ""}
                </td>

                <td className="td overflow-x-auto">
                  {item?.end_checkin_online_date
                    ? moment(item?.end_checkin_online_date).format(
                        "DD/MM/YYYY HH:mm:ss"
                      )
                    : ""}
                </td>

                <td className="td">
                  <SwitchButton
                    checked={item?.is_have_online_checkin === 1}
                    disabled={!isHaveActionPermission("", "e_waiver", "edit")}
                    onChange={() => _toggleActive(item)}
                  />
                </td>

                <td className="td py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                  <div className="float-right">
                    <DropdownMenu
                      label={<DotsVerticalIcon className="w-4" />}
                      items={[
                        {
                          label: "View",
                          href: `/ewaiver/detail/${item?.event_id}`,
                          //   target: "_blank",
                        },
                        ...(isHaveActionPermission("", "e_waiver", "edit")
                          ? [
                              {
                                label: "Edit",
                                href: `/ewaiver/edit/${item?.event_id}`,
                                //   target: "_blank",
                              },
                            ]
                          : []),
                        {
                          label: "Tracking",
                          onClick: () => {
                            console.log(`Tracking: ${item}`);
                            handleApplyAction("tracking", item);
                          },
                          //   target: "_blank",
                        },
                        // {
                        //   label: "Log",
                        //   onClick: () => {
                        //     console.log(`Log: ${item}`);
                        //   },
                        //   //   target: "_blank",
                        // },
                      ]}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
